<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<form  [formGroup]="form" novalidate *ngIf="loadInfo" @fadeInAnimation>
  <p class="text-info">
    Por  favor  califica  cada  una  de  las  siguientes  afirmaciones  sobre  tu  estado  actual  del  1  al  6 utilizando la siguiente escala.
  </p>

  <div nz-row class="mt-xs mb-md tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100  tw-w-full">
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">1. Fuertemente en desacuerdo</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">2. Moderadamente en desacuerdo</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">3. Medianamente en desacuerdo</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">4. Medianamente de acuerdo</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">5. Moderadamente de acuerdo</p>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <p class="text-info-bold mb-xs">6. Fuertemente de acuerdo</p>
    </div>
  </div>

  <div class=""> <!-- tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mt-3 tw-w-full -->
    <div nz-row [nzGutter]="[30, 15]">
      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">1. Tengo a alguien que me conoce bien para hablar cuando tengo problemas.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="someoneToTalkAboutMyProblems"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('someoneToTalkAboutMyProblems').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('someoneToTalkAboutMyProblems')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">2. Sé que puedo contar con mis amigos y/o familiares en tiempos de crisis.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="trustWithFamilyAndFriends" [nzMarks]="marks" [nzDots]="true"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('trustWithFamilyAndFriends').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('trustWithFamilyAndFriends')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">3. Hay al menos una persona que conozco que me ama y/o me necesita.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="leastOneWhoLovesMe" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('leastOneWhoLovesMe').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('leastOneWhoLovesMe')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">4. Encuentro tiempo para hacer cosas divertidas e interesantes.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="timeForHaveFun"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('timeForHaveFun').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('timeForHaveFun')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">5. Disfruto pasar tiempo con amigos y/o familiares.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="enjoyFriendsAndFamilyTime"  [nzMarks]="marks" [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('enjoyFriendsAndFamilyTime').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('enjoyFriendsAndFamilyTime')"></app-message-field>
      </div>


      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">6. Me llevo bien con la gente en general.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="getWellWithPeople" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('getWellWithPeople').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('getWellWithPeople')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">7. Trato de hacer cosas que me hacen feliz.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="tryDoThingMakeMeHappy" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('tryDoThingMakeMeHappy').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('tryDoThingMakeMeHappy')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">8. Me siento feliz a menudo.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="feelHappyOften" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('feelHappyOften').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('feelHappyOften')"></app-message-field>
      </div>

      <div nz-col nzXs="24" nzMd="24" nzLg="12" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form tw-h-3/6">9. Disfruto de la vida.</div>
        <div class="tw-flex tw-items-center tw-h-3/6">
          <i nz-icon nzType="frown"></i>
          <nz-slider class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px" formControlName="enjoyLife" [nzMarks]="marks"  [nzMin]="1" [nzMax]="6" [nzStep]="1" [nzTipFormatter]="sliderFormatter"></nz-slider>
          <i nz-icon nzType="smile"></i>
        </div>
        <div>
          <p class="text-info">{{ this.form.get('enjoyLife').value | getStatementStatus}}</p>
        </div>
        <app-message-field [field]="form.get('enjoyLife')"></app-message-field>
      </div>
    </div>

  </div>
</form>

<div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
  <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
</div>
